export default __webpack_public_path__ + "static/media/battery_charger_new.05138135.svg";